var map = {
	"./card_100_loses.mp3": 8845,
	"./card_10_loses.mp3": 99761,
	"./card_11_loses.mp3": 84072,
	"./card_12_loses.mp3": 3327,
	"./card_13_loses.mp3": 68830,
	"./card_14_loses.mp3": 60765,
	"./card_15_loses.mp3": 71380,
	"./card_16_loses.mp3": 43,
	"./card_17_loses.mp3": 40922,
	"./card_18_loses.mp3": 89753,
	"./card_19_loses.mp3": 83248,
	"./card_1_loses.mp3": 43293,
	"./card_20_loses.mp3": 29572,
	"./card_21_loses.mp3": 34637,
	"./card_22_loses.mp3": 17802,
	"./card_23_loses.mp3": 53467,
	"./card_24_loses.mp3": 1688,
	"./card_25_loses.mp3": 36545,
	"./card_26_loses.mp3": 33582,
	"./card_27_loses.mp3": 80335,
	"./card_28_loses.mp3": 4908,
	"./card_29_loses.mp3": 19605,
	"./card_2_loses.mp3": 23450,
	"./card_30_loses.mp3": 63371,
	"./card_31_loses.mp3": 32122,
	"./card_32_loses.mp3": 43325,
	"./card_33_loses.mp3": 90228,
	"./card_34_loses.mp3": 78847,
	"./card_35_loses.mp3": 52702,
	"./card_36_loses.mp3": 89105,
	"./card_37_loses.mp3": 15368,
	"./card_38_loses.mp3": 95059,
	"./card_39_loses.mp3": 71298,
	"./card_3_loses.mp3": 82571,
	"./card_40_loses.mp3": 74046,
	"./card_41_loses.mp3": 83839,
	"./card_42_loses.mp3": 36712,
	"./card_43_loses.mp3": 10449,
	"./card_44_loses.mp3": 53466,
	"./card_45_loses.mp3": 84715,
	"./card_46_loses.mp3": 11572,
	"./card_47_loses.mp3": 64669,
	"./card_48_loses.mp3": 33542,
	"./card_49_loses.mp3": 70855,
	"./card_4_loses.mp3": 66600,
	"./card_50_loses.mp3": 91533,
	"./card_51_loses.mp3": 21540,
	"./card_52_loses.mp3": 74651,
	"./card_53_loses.mp3": 71082,
	"./card_54_loses.mp3": 32065,
	"./card_55_loses.mp3": 33496,
	"./card_56_loses.mp3": 19375,
	"./card_57_loses.mp3": 35694,
	"./card_58_loses.mp3": 24597,
	"./card_59_loses.mp3": 73388,
	"./card_5_loses.mp3": 82289,
	"./card_60_loses.mp3": 63248,
	"./card_61_loses.mp3": 17401,
	"./card_62_loses.mp3": 83846,
	"./card_63_loses.mp3": 30919,
	"./card_64_loses.mp3": 79420,
	"./card_65_loses.mp3": 23653,
	"./card_66_loses.mp3": 92386,
	"./card_67_loses.mp3": 94835,
	"./card_68_loses.mp3": 94728,
	"./card_69_loses.mp3": 88337,
	"./card_6_loses.mp3": 51358,
	"./card_70_loses.mp3": 81303,
	"./card_71_loses.mp3": 87958,
	"./card_72_loses.mp3": 39785,
	"./card_73_loses.mp3": 97440,
	"./card_74_loses.mp3": 7043,
	"./card_75_loses.mp3": 7314,
	"./card_76_loses.mp3": 93109,
	"./card_77_loses.mp3": 99308,
	"./card_78_loses.mp3": 89135,
	"./card_79_loses.mp3": 79118,
	"./card_7_loses.mp3": 85855,
	"./card_80_loses.mp3": 35930,
	"./card_81_loses.mp3": 78699,
	"./card_82_loses.mp3": 50036,
	"./card_83_loses.mp3": 55773,
	"./card_84_loses.mp3": 63838,
	"./card_85_loses.mp3": 98335,
	"./card_86_loses.mp3": 79080,
	"./card_87_loses.mp3": 94769,
	"./card_88_loses.mp3": 91746,
	"./card_89_loses.mp3": 58771,
	"./card_8_loses.mp3": 68892,
	"./card_90_loses.mp3": 14633,
	"./card_91_loses.mp3": 3136,
	"./card_92_loses.mp3": 41111,
	"./card_93_loses.mp3": 56566,
	"./card_94_loses.mp3": 14613,
	"./card_95_loses.mp3": 99916,
	"./card_96_loses.mp3": 86787,
	"./card_97_loses.mp3": 45106,
	"./card_98_loses.mp3": 15201,
	"./card_99_loses.mp3": 96696,
	"./card_9_loses.mp3": 74309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61966;